import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import { router } from './router'
import './assets/main.css'
import { placeBeneathStatusBar } from './native/status-bar'
import { useThemeStore } from './stores/theme'
import { routeAppLinks } from './native/app-links'
import { routeNotificationTaps } from './native/notification-taps'

const app = createApp(App)
app.use(createPinia())
app.use(router)
app.mount('#app')
placeBeneathStatusBar()
// After mounting, so Pinia exists; the class itself went on before the first
// paint, from the inline script in index.html.
useThemeStore().start()
routeAppLinks(router)
routeNotificationTaps(router)
